module.exports = __webpack_public_path__ + "img/mail-checkout.53276948.svg";